import React from 'react';

interface DermaHistoryProps {
  data: {
    onset: string;
    evolution: string;
    previous_episodes: boolean;
    previous_diagnosis: string;
    previous_treatment: string;
    trigger_factors: string;
    allergies: string;
    family_history: string;
  };
  onChange: (field: string, value: any) => void;
}

const ONSET_OPTIONS = [
  { value: '', label: 'Seleccionar...' },
  { value: 'agudo (<2 semanas)', label: 'Agudo (<2 semanas)' },
  { value: 'subagudo (2-6 semanas)', label: 'Subagudo (2-6 semanas)' },
  { value: 'crónico (>6 semanas)', label: 'Crónico (>6 semanas)' },
];

const EVOLUTION_OPTIONS = [
  { value: '', label: 'Seleccionar...' },
  { value: 'estable', label: 'Estable' },
  { value: 'progresivo', label: 'Progresivo' },
  { value: 'cíclico/recurrente', label: 'Cíclico/Recurrente' },
  { value: 'mejorando', label: 'Mejorando' },
];

const DermaHistory: React.FC<DermaHistoryProps> = ({ data, onChange }) => {
  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">
          <i className="fa fa-history me-1"></i>
          Historia de la Enfermedad
        </h5>
        <div className="row mt-3">
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Inicio</label>
              <select
                className="form-select"
                value={data.onset}
                onChange={e => onChange('onset', e.target.value)}
              >
                {ONSET_OPTIONS.map(o => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="mb-3">
              <label className="form-label">Evolución</label>
              <select
                className="form-select"
                value={data.evolution}
                onChange={e => onChange('evolution', e.target.value)}
              >
                {EVOLUTION_OPTIONS.map(o => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-4 d-flex align-items-end">
            <div className="mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="previous_episodes"
                  checked={data.previous_episodes}
                  onChange={e => onChange('previous_episodes', e.target.checked)}
                />
                <label className="form-check-label" htmlFor="previous_episodes">
                  Episodios Previos
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Diagnóstico Previo</label>
              <input
                type="text"
                className="form-control"
                value={data.previous_diagnosis}
                onChange={e => onChange('previous_diagnosis', e.target.value)}
                placeholder="Diagnóstico(s) previo(s)..."
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Tratamiento Previo</label>
              <input
                type="text"
                className="form-control"
                value={data.previous_treatment}
                onChange={e => onChange('previous_treatment', e.target.value)}
                placeholder="Tratamiento(s) previo(s)..."
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Factores Desencadenantes</label>
              <textarea
                className="form-control"
                rows={2}
                value={data.trigger_factors}
                onChange={e => onChange('trigger_factors', e.target.value)}
                placeholder="Estrés, alimentos, fármacos, clima, etc..."
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label">Alergias</label>
              <textarea
                className="form-control"
                rows={2}
                value={data.allergies}
                onChange={e => onChange('allergies', e.target.value)}
                placeholder="Alergias medicamentosas, contacto, etc..."
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">Historia Familiar</label>
              <textarea
                className="form-control"
                rows={2}
                value={data.family_history}
                onChange={e => onChange('family_history', e.target.value)}
                placeholder="Antecedentes familiares de enfermedades dermatológicas..."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DermaHistory;
